<template>
  <v-container class="pr-0 pl-0" fluid>

    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10 mb-2" :disabled="dialogLoader">
          <v-card-title class="">Dados da Plataforma</v-card-title>
          <v-card-text>
            <v-select
              :items="daysItems"
              v-model="days"
              item-text="title"
              item-value="value"
              label="Período"
              @change="loadReportData"
            ></v-select>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" xl="4" md="6" sm="12">
        <v-card class="elevation-10 mb-2" dense v-if="treinosPorEsporteData" :disabled="dialogLoader">
          <v-card-title class="">Quantidade por Esporte</v-card-title>
          <v-card-text>
            <AllEsportesPieChart :chartData="treinosPorEsporteData" :key="'treinos-por-esporte-pie'" ref="treinos-por-esporte-pie"/>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" xl="4" md="6" sm="12">
        <v-card class="elevation-10 mb-2" dense v-if="treinosByDayOfWeek" :disabled="dialogLoader">
          <v-card-title class="">Treinos por Dia da Semana</v-card-title>
          <v-card-text>
            <AllTreinosBarChart :chartData="treinosByDayOfWeek" :key="'day-week-treinos-bar'" ref="day-week-treinos-bar"/>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col cols="12" xl="4" md="6" sm="12">
        <v-card class="elevation-10 mb-2" dense v-if="treinosChartData" :disabled="dialogLoader">
          <v-card-title class="">Todos os Esportes</v-card-title>
          <v-card-text>
            <AllTreinosBarChart :chartData="treinosChartData" :key="'all-treinos-bar'" ref="all-treinos-bar"/>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" xl="4" md="6" sm="12">
        <v-card class="elevation-10 mb-2" dense v-if="treinosCiclismoChartData" :disabled="dialogLoader">
          <v-card-title class="">Ciclismo</v-card-title>
          <v-card-text>
            <AllTreinosBarChartEsporte :chartData="treinosCiclismoChartData" :key="'ciclismo-treinos-bar'" ref="ciclismo-treinos-bar"/>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" xl="4" md="6" sm="12">
        <v-card class="elevation-10 mb-2" dense v-if="treinosCorridaChartData" :disabled="dialogLoader">
          <v-card-title class="">Corrida</v-card-title>
          <v-card-text>
            <AllTreinosBarChartEsporte :chartData="treinosCorridaChartData" :key="'corrida-treinos-bar'" ref="corrida-treinos-bar"/>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" xl="4" md="6" sm="12">
        <v-card class="elevation-10 mb-2" dense v-if="treinosNatacaoChartData" :disabled="dialogLoader">
          <v-card-title class="">Natação</v-card-title>
          <v-card-text>
            <AllTreinosBarChartEsporte :chartData="treinosNatacaoChartData" :key="'natacao-treinos-bar'" ref="natacao-treinos-bar"/>
          </v-card-text>
        </v-card>
      </v-col>
  </v-row>

    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Carregando os dados...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>

//import axios from 'axios';
import HOST from '@/ws'
import AllTreinosBarChart from '../../components/report/admin/AllTreinosBarChart.vue';
import AllEsportesPieChart from '../../components/report/admin/AllEsportesPieChart.vue';
import AllTreinosBarChartEsporte from '../../components/report/admin/AllTreinosBarChartEsporte.vue';
import { myMixin } from '../../mixin'
//import SnackBar from "../snackbar";


export default {
  props: {
    source: String
  },

  mixins : [
    myMixin
  ],

  components : {
    AllTreinosBarChart,
    AllTreinosBarChartEsporte,
    AllEsportesPieChart,
  },

  mounted () {
    this.loadReportData();
  },

  data: () => ({
    
    dialogLoader : false,
    
    treinosChartData : null,
    treinosCiclismoChartData : null,
    treinosCorridaChartData : null,
    treinosNatacaoChartData : null,
    treinosByDayOfWeek : null,

    treinosPorEsporteData : null,

    days : 180,
    daysItems : [
      {title : 'Últimos 30 dias', value : 30},
      {title : 'Últimos 90 dias', value : 90},
      {title : '6 meses', value : 180},
      {title : '1 ano', value : 365},
    ]
  }),

  methods : {

    async loadReportData() {
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` },
      };

      try {
        this.dialogLoader = true;

        // Load all treinos (first request)
        let response = await this.axios.get(HOST.HOST + '/api/reports-app/treinos-by-month-all?days=' + this.days, config);
        const profitData = response.data;
        //console.log('\n\n' + JSON.stringify(response.data));

        const profitMonths = profitData.map(item => item.monthYear);
        const profitValues = profitData.map(item => item.treinoCount);
        this.treinosChartData = {
          labels: profitMonths,
          datasets: [
            {
              label: 'Resultados',
              data: profitValues,
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
          ],
        };

        // Load ciclismo treinos (second request)
        response = await this.axios.get(HOST.HOST + '/api/reports-app/treinos-by-month-esporte?days=' + this.days + "&esporte=Ciclismo", config);
        const ciclismoData = response.data;
        //console.log('\n\n' + JSON.stringify(response.data));

        const ciclismoMonth = ciclismoData.map(item => item.monthYear);
        const ciclismoValues = ciclismoData.map(item => item.treinoCount);
        this.treinosCiclismoChartData = {
          labels: ciclismoMonth,
          datasets: [
            {
              label: 'Resultados',
              data: ciclismoValues,
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
          ],
        };

        // Load corrida treinos (second request)
        response = await this.axios.get(HOST.HOST + '/api/reports-app/treinos-by-month-esporte?days=' + this.days + "&esporte=Corrida", config);
        const corridaData = response.data;
        //console.log('\n\n' + JSON.stringify(response.data));

        const corridaMonth = corridaData.map(item => item.monthYear);
        const corridaValues = corridaData.map(item => item.treinoCount);
        this.treinosCorridaChartData = {
          labels: corridaMonth,
          datasets: [
            {
              label: 'Resultados',
              data: corridaValues,
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
          ],
        };

        // Load natacao treinos (second request)
        response = await this.axios.get(HOST.HOST + '/api/reports-app/treinos-by-month-esporte?days=' + this.days + "&esporte=Natação", config);
        const natacaoData = response.data;
        //console.log('\n\n' + JSON.stringify(response.data));

        const natacaoMonth = natacaoData.map(item => item.monthYear);
        const natacaoValues = natacaoData.map(item => item.treinoCount);
        this.treinosNatacaoChartData = {
          labels: natacaoMonth,
          datasets: [
            {
              label: 'Resultados',
              data: natacaoValues,
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
          ],
        };

        // Load all treinos per week day (second request)
        response = await this.axios.get(HOST.HOST + '/api/reports-app/treinos-by-day-week-all?days=' + this.days, config);
        const treinosByWeekDay = response.data;
        console.log('\n\n' + JSON.stringify(response.data));

        const treinoDayOfWeek = treinosByWeekDay.map(item => item.dayOfWeek);
        const treinoCount = treinosByWeekDay.map(item => item.treinoCount);
        this.treinosByDayOfWeek = {
          labels: treinoDayOfWeek,
          datasets: [
            {
              label: 'Resultados',
              data: treinoCount,
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 1,
            },
          ],
        };

        // Load all esportes (second request)
        response = await this.axios.get(HOST.HOST + '/api/reports-app/treinos-count-all?days=' + this.days, config);
        const allEsportesData = response.data;
        //console.log('\n\n' + JSON.stringify(response.data));

        const allEsportesMonth = allEsportesData.map(item => item.sport);
        const allEsportesValues = allEsportesData.map(item => item.sportCount);
        this.treinosPorEsporteData = {
          labels: allEsportesMonth,
          datasets: [
            {
              label: 'Resultados',
              data: allEsportesValues,
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)', // Red
                'rgba(54, 162, 235, 0.2)', // Blue
                'rgba(255, 206, 86, 0.2)', // Yellow
                'rgba(75, 192, 192, 0.2)', // Green
                'rgba(153, 102, 255, 0.2)', // Purple
                'rgba(255, 159, 64, 0.2)', // Orange
              ],
              borderColor: [
                'rgba(255, 99, 132, 1)', // Red
                'rgba(54, 162, 235, 1)', // Blue
                'rgba(255, 206, 86, 1)', // Yellow
                'rgba(75, 192, 192, 1)', // Green
                'rgba(153, 102, 255, 1)', // Purple
                'rgba(255, 159, 64, 1)', // Orange
              ],
              borderWidth: 1,
            },
          ],
        };

        // // Load transaction count by month (second request)
        // response = await this.axios.post(HOST.HOST + '/robot/quantity-by-month/12', {}, config);
        // const transactionData = response.data;
        // console.log('\n\n' + JSON.stringify(response.data));

        // const transactionMonths = transactionData.map(item => item.transactionMonth);
        // const transactionValues = transactionData.map(item => item.transactionCount);
        // this.transactionCountData = {
        //   labels: transactionMonths,
        //   datasets: [
        //     {
        //       label: 'Quantidade de transações',
        //       data: transactionValues,
        //       backgroundColor: 'rgba(75, 192, 192, 0.2)',
        //       borderColor: 'rgba(75, 192, 192, 1)',
        //       borderWidth: 1,
        //     },
        //   ],
        // };

      } catch (error) {
        console.error('Error loading report data:', error);
        this.$store.commit("logout");
        this.$router.push("/");
      } finally {
        this.dialogLoader = false;
      }
    },

    
  }
};
</script>